import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ProfilePageHeader } from '@sorare/core/src/components/navigation/ProfilePageHeader';
import { SearchLayoutRoot } from '@sorare/core/src/components/search/SearchLayout/ui';
import { AlgoliaCardIndexesNames } from '@sorare/core/src/contexts/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { MyCardsSearch } from '@sorare/marketplace/src/searchCards/MyCardsSearch';

import { getNbDecks } from '@sorare/gameplay/src/lib/getNbDecks';

import { USInfoModal } from '@sorare/us-sports/src/components/USInfoModal';

import { myClubFilters } from 'components/searchCards/cardFilters';

import {
  NbaUserCardsQuery,
  NbaUserCardsQueryVariables,
} from './__generated__/page.graphql';

const availableSorts: AlgoliaCardIndexesNames = [
  'Cards New',
  'Cards Highest Average Score',
  'Cards Highest Price',
  'Cards Lowest Price',
];

const NBA_MY_CARDS_PAGE_QUERY = gql`
  query NbaUserCardsQuery($sport: Sport!) {
    currentUser {
      slug
      ...getNbDecks_publicUserInfoInterface
    }
  }
  ${getNbDecks.fragments.publicUserInfoInterface}
` as TypedDocumentNode<NbaUserCardsQuery, NbaUserCardsQueryVariables>;

const NBAMyCardsPage = () => {
  const { currentUser } = useCurrentUserContext();
  const { data } = useQuery(NBA_MY_CARDS_PAGE_QUERY, {
    variables: {
      sport: Sport.NBA,
    },
  });
  const nbDecks = getNbDecks(data?.currentUser);
  const cardFilters = myClubFilters(nbDecks > 0);

  if (!currentUser) {
    return null;
  }

  return (
    <SearchLayoutRoot>
      <ProfilePageHeader />
      <MyCardsSearch
        sport={Sport.NBA}
        analyticsTags={['Gallery', 'NBA']}
        availableSorts={availableSorts}
        cardFilters={cardFilters}
        playerDetailsComponent={USInfoModal}
      />
    </SearchLayoutRoot>
  );
};

export default NBAMyCardsPage;
